// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3Nln3","col":"styles_col__2yvwP"};